import { preventMarginCollapse } from 'styles/common';
import { below } from 'utils/breakpoint';
import { getColorRGBA } from 'utils/colorConvert';
import { IS_IFRAME_MODE, IFRAME_MODE_MIN_HEIGHT, POWER_BY_HEIGHT } from 'config/envVariable';
import { above } from 'utils/breakpoint';
import { defaultPopupColor } from 'config/promoDefaultSettingValue';
export const clientBodyStyle = !IS_IFRAME_MODE ? 'height: 100%; overflow: auto;' : '';
export const appContainerStyle = `
    max-width: 720px;
    min-height: calc(
        ${IS_IFRAME_MODE ? `${IFRAME_MODE_MIN_HEIGHT}px` : '100%'} - ${POWER_BY_HEIGHT}px
    );
    margin: 0 auto;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
       ${IS_IFRAME_MODE && above('sm') ? 'padding: 24px 0;' : ''}
`;
export const clientSmallWrapperStyle = `
    max-width: 720px;

    @media only screen and (max-width: 720px) {
        width: 100%;
    }
`;
export const clientBigWrapperStyle = `
    max-width: 960px;

    @media only screen and (max-width: 767px) {
        width: 100%;
    }
`;
export const routeContainerStyle = `
    width: 100%;
    border-radius: 8px;
`;

export const shadowLightStyle = `
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
`;
export const shadowDarkStyle = `
    box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.2), 0 3px 3px -2px rgba(0, 0, 0, 0.12), 0 3px 4px 0 rgba(0, 0, 0, 0.14);
`;

const loadingBgImg = `data:image/svg+xml;base64,PCEtLSBCeSBTYW0gSGVyYmVydCAoQHNoZXJiKSwgZm9yIGV2ZXJ5b25lLiBNb3JlIEAgaHR0cDovL2dvby5nbC83QUp6YkwgLS0+Cjxzdmcgd2lkdGg9IjQ0IiBoZWlnaHQ9IjQ0IiB2aWV3Qm94PSIwIDAgNDQgNDQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgc3Ryb2tlPSIjZmZmIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLXdpZHRoPSIyIj4KICAgICAgICA8Y2lyY2xlIGN4PSIyMiIgY3k9IjIyIiByPSIxIj4KICAgICAgICAgICAgPGFuaW1hdGUgYXR0cmlidXRlTmFtZT0iciIKICAgICAgICAgICAgICAgIGJlZ2luPSIwcyIgZHVyPSIxLjhzIgogICAgICAgICAgICAgICAgdmFsdWVzPSIxOyAyMCIKICAgICAgICAgICAgICAgIGNhbGNNb2RlPSJzcGxpbmUiCiAgICAgICAgICAgICAgICBrZXlUaW1lcz0iMDsgMSIKICAgICAgICAgICAgICAgIGtleVNwbGluZXM9IjAuMTY1LCAwLjg0LCAwLjQ0LCAxIgogICAgICAgICAgICAgICAgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIC8+CiAgICAgICAgICAgIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9InN0cm9rZS1vcGFjaXR5IgogICAgICAgICAgICAgICAgYmVnaW49IjBzIiBkdXI9IjEuOHMiCiAgICAgICAgICAgICAgICB2YWx1ZXM9IjE7IDAiCiAgICAgICAgICAgICAgICBjYWxjTW9kZT0ic3BsaW5lIgogICAgICAgICAgICAgICAga2V5VGltZXM9IjA7IDEiCiAgICAgICAgICAgICAgICBrZXlTcGxpbmVzPSIwLjMsIDAuNjEsIDAuMzU1LCAxIgogICAgICAgICAgICAgICAgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIC8+CiAgICAgICAgPC9jaXJjbGU+CiAgICAgICAgPGNpcmNsZSBjeD0iMjIiIGN5PSIyMiIgcj0iMSI+CiAgICAgICAgICAgIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9InIiCiAgICAgICAgICAgICAgICBiZWdpbj0iLTAuOXMiIGR1cj0iMS44cyIKICAgICAgICAgICAgICAgIHZhbHVlcz0iMTsgMjAiCiAgICAgICAgICAgICAgICBjYWxjTW9kZT0ic3BsaW5lIgogICAgICAgICAgICAgICAga2V5VGltZXM9IjA7IDEiCiAgICAgICAgICAgICAgICBrZXlTcGxpbmVzPSIwLjE2NSwgMC44NCwgMC40NCwgMSIKICAgICAgICAgICAgICAgIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiAvPgogICAgICAgICAgICA8YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJzdHJva2Utb3BhY2l0eSIKICAgICAgICAgICAgICAgIGJlZ2luPSItMC45cyIgZHVyPSIxLjhzIgogICAgICAgICAgICAgICAgdmFsdWVzPSIxOyAwIgogICAgICAgICAgICAgICAgY2FsY01vZGU9InNwbGluZSIKICAgICAgICAgICAgICAgIGtleVRpbWVzPSIwOyAxIgogICAgICAgICAgICAgICAga2V5U3BsaW5lcz0iMC4zLCAwLjYxLCAwLjM1NSwgMSIKICAgICAgICAgICAgICAgIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiAvPgogICAgICAgIDwvY2lyY2xlPgogICAgPC9nPgo8L3N2Zz4=`;
export const loadingBgImgStyle = `rgb(205, 205, 205) url('${loadingBgImg}') no-repeat center`;

export function convertSettingStyle2ComponentStyle(settingStyle = {}) {
    const {
        contentBgType,
        contentBgColor,
        contentAlign,
        contentBorderRadius,
        buttonBgColor,
        buttonTextColor,
        buttonSize,
        optionBgColor,
        optionTextColor,
        titleColor,
        descColor,
        answerColor,
        lotteryTaskTextColor,
        lotteryTaskBgColor,
        titleBgColor,
        buttonBorderColor,
        actionButtonText,
        popupTextColor,
        popupButtonTextColor,
        popupButtonBgColor,
        popupBgColor,
        progressBarBgColor,
        progressBarTextColor,
        enableProgressBar,
        textSize
    } = settingStyle;
    return {
        contentBgType,
        contentBgColor,
        isContentBgColorTransparent: (contentBgColor && getColorRGBA(contentBgColor).alpha) === 0,
        contentAlign,
        contentBorderRadius,
        titleColor,
        descColor,
        answerColor,
        optionBgColor,
        optionTextColor,
        buttonBgColor,
        buttonTextColor,
        buttonSize,
        lotteryTaskTextColor,
        lotteryTaskBgColor,
        titleBgColor,
        buttonBorderColor,
        actionButtonText,
        popupTextColor: popupTextColor || defaultPopupColor.popupTextColor,
        popupButtonTextColor: popupButtonTextColor || defaultPopupColor.popupButtonTextColor,
        popupButtonBgColor: popupButtonBgColor || defaultPopupColor.popupButtonBgColor,
        popupBgColor: popupBgColor || defaultPopupColor.popupBgColor,
        progressBarBgColor,
        progressBarTextColor,
        enableProgressBar,
        textSize
    };
}
export function convertSettingStyle2FormBasedEditorStyle(settingStyle = {}) {
    const {
        optionBgColor,
        optionTextColor,
        titleColor,
        descColor,
        bgType,
        bgColor,
        bgImgUrl,
        contentBgColor,
        contentAlign,
        buttonBgColor,
        buttonTextColor,
        buttonSize,
        contentBorderRadius = 8,
        progressBarBgColor,
        progressBarTextColor,
        enableProgressBar,
        textSize
    } = settingStyle;
    return {
        titleColor,
        descColor,
        optionTextColor,
        optionBgColor,
        background: {
            type: bgType,
            color: bgColor,
            imageUrl: bgImgUrl
        },
        contentBackground: {
            type: 1,
            color: contentBgColor
        },
        contentAlign,
        buttonTextColor,
        buttonBgColor,
        buttonSize,
        isContentBgTransparent: (contentBgColor && getColorRGBA(contentBgColor).alpha) === 0,
        contentBorderRadius,
        progressBarBgColor,
        progressBarTextColor,
        enableProgressBar,
        textSize
    };
}

export const resultHeaderContainerStyle = `
        ${preventMarginCollapse}
          padding: 16px;    
    `;
export const resultHeaderBtnWrapperStyle = `
    padding: 16px 0;
    ${below('sm')} {
        padding: 8px 0;
    }
`;

export const resultFooterContainerStyle = `
        ${preventMarginCollapse}
        width: 100%;     
    `;

export const shareButtonWrapperStyle = `
    padding: 8px 0 16px 0;
`;
